var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"d-flex menu-tab-loader align-center mt-4",class:_vm.$vuetify.breakpoint.smAndDown ? 'mb-4' : 'mb-5'},[_c('span',{staticClass:"v-skeleton-loader__bone"}),_c('span',{staticClass:"v-skeleton-loader__bone"}),_c('span',{staticClass:"v-skeleton-loader__bone"})])
}
var staticRenderFns = []

export { render, staticRenderFns }